var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512.00033 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: 256.000165,
    y2: 256.000165
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea80fc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m229.144531 492c0 11.046875-8.957031 20-20.003906 20h-189.140625c-11.046875 0-20-8.953125-20-20v-472c0-11.046875 8.953125-20 20-20h189.144531c11.042969 0 20 8.953125 20 20s-8.953125 20-20 20h-169.144531v432h169.140625c11.046875 0 20.003906 8.953125 20.003906 20zm277.007813-250.144531-113.136719-113.136719c-7.8125-7.808594-20.472656-7.808594-28.285156 0-7.808594 7.8125-7.808594 20.472656 0 28.285156l78.996093 78.996094h-347.722656c-11.046875 0-20 8.953125-20 20s8.953125 20 20 20h347.722656l-78.996093 78.992188c-7.808594 7.8125-7.808594 20.476562 0 28.285156 7.8125 7.8125 20.476562 7.808594 28.285156 0l113.140625-113.136719c2.683594-2.675781 4.695312-6.308594 5.472656-10.234375 1.246094-6.292969-.648437-13.226562-5.476562-18.050781zm0 0",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8e04380a.svg";
export { ForwardRef as ReactComponent };